module.exports = __webpack_public_path__ + "img/icon-hospital-line.a037b30.svg";